import {
  FETCH_STUDENTS_REQUEST,
  FETCH_STUDENTS_SUCCESS,
  FETCH_STUDENTS_FAILURE,
  FETCH_FACULTY_REQUEST,
  FETCH_FACULTY_SUCCESS,
  FETCH_FACULTY_FAILURE,
} from "../actions/userManagementActions";

const initialState = {
  students: [],
  faculty: [],
  paginationStudents: {
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    limit: 10,
  },
  paginationFaculty: {
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    limit: 10,
  },
  loading: false,
  error: null,
};

const userManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    // STUDENTS
    case FETCH_STUDENTS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_STUDENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        students: action.payload.students,
        paginationStudents: action.payload.pagination,
      };
    case FETCH_STUDENTS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // FACULTY
    case FETCH_FACULTY_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_FACULTY_SUCCESS:
      return {
        ...state,
        loading: false,
        faculty: action.payload.faculty,
        paginationFaculty: action.payload.pagination,
      };
    case FETCH_FACULTY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default userManagementReducer;